import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Select,
    Input,
    VStack,
    HStack,
    useToast
} from '@chakra-ui/react';
import { authAPI } from '../services/api';

const ExportReportModal = ({ isOpen, onClose }) => {
    const toast = useToast();
    const [loading, setLoading] = useState(false);

    // Default Date Range: Today ~ Today
    const today = new Date().toISOString().split('T')[0];
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [department, setDepartment] = useState('All');

    const handleExport = async () => {
        if (!startDate || !endDate) {
            toast({
                title: "請選擇日期",
                status: "warning",
                duration: 2000,
            });
            return;
        }

        if (startDate > endDate) {
            toast({
                title: "開始日期不能晚於結束日期",
                status: "error",
                duration: 2000,
            });
            return;
        }

        try {
            setLoading(true);

            // Prepare Query Params
            const params = {
                start_date: startDate,
                end_date: endDate
            };

            if (department !== 'All') {
                // If department is 'AfterSchool' or 'English', pass it.
                // Note: Backend handles empty department as All if None passed?
                // Or we pass explicit param.
                params.department = department;
            }

            // Call API
            // Note: We need to implement this in 'api.js' or call axios directly here for blob
            // Assuming authAPI.getReport(params) returns blob response

            // Since API is new, let's use authAPI helper if available or axios directly.
            // But authAPI usually wraps axios. Let's assume we'll add `getAttendanceReport` to api.js.

            const response = await authAPI.getAttendanceReport(params);

            // Handle Blob Download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            // Extract filename from header or custom
            const filename = `Attendance_Export_${startDate}_${endDate}.xlsx`;
            link.setAttribute('download', filename);

            document.body.appendChild(link);
            link.click();
            link.remove();

            toast({
                title: "匯出成功",
                status: "success",
                duration: 2000,
            });
            onClose();

        } catch (error) {
            console.error("Export failed", error);
            const msg = error.response?.data?.detail || "匯出失敗，請稍後再試";
            toast({
                title: "匯出失敗",
                description: msg,
                status: "error",
                duration: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>匯出進階出勤報表</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4}>
                        <FormControl>
                            <FormLabel>部門選擇</FormLabel>
                            <Select value={department} onChange={(e) => setDepartment(e.target.value)}>
                                <option value="All">全部部門 (All)</option>
                                <option value="AfterSchool">全科班 (After School)</option>
                                <option value="English">英文部 (English)</option>
                            </Select>
                        </FormControl>

                        <FormControl>
                            <FormLabel>日期區間</FormLabel>
                            <HStack>
                                <Input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                                <Input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </HStack>
                        </FormControl>
                    </VStack>
                </ModalBody>

                <ModalFooter>
                    <Button variant="ghost" onClick={onClose} mr={3}>
                        取消
                    </Button>
                    <Button colorScheme="blue" onClick={handleExport} isLoading={loading}>
                        匯出 Excel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ExportReportModal;
